import { useState } from 'react';

import { PageSpinner } from '@/components/UI/PageSuspense';
import { isAfterFirstRender } from '@/renderer/utils/clientNavigation';

export default { component: LoadingComponent, layout: LoadingLayout };

function LoadingComponent() {
  // Applies on a component-level
  return <div>Loading section...</div>;
}

function LoadingLayout() {
  // Applies to the page and all layouts. Empty on the first render, so it matches
  // the server HTML while hydrating and the boot screen (#ras-loading-page) covers
  // a cold load. After that, it is the fallback for pages mounted by a client
  // navigation, which leave out their own spinner boundary (PageSuspense): a
  // transition keeps the previous page up instead, so this only shows when a page
  // suspends again outside a navigation.
  const [spinner] = useState(isAfterFirstRender);

  return spinner ? <PageSpinner /> : null;
}
